export const getTopicFilters = () : string [] => {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.get("topics")?.split(',') ?? [];
}